import {Component} from "@angular/core";

@Component({
    templateUrl: './footer.component.html',
    selector: 'gar-footer'
})

export class FooterComponent {

}
